import Common from '../../native-base-theme/variables/commonColor';

export default function useTheme() {
return Common;
}